import React, { useState, useEffect, useRef } from "react";
import { ApiService } from "../services";
import styled from "styled-components";
import { Search, Close, ArrowDropDown } from "@material-ui/icons";
import { useDetectOutsideClick } from "../useDetectOutsideClick";

const LI = styled.li`
  padding: 6px 8px;
  color: #333;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background: #f8310e;
    color: #fff;
  }
`;

const Input = styled.input`
  width: calc(100% - 45px);
  /* min-width: 350px; */
  max-width: 450px;
  margin: 5px 0 0;
  height: 30px;
  background: transparent;
  border: 0px;
  outline: 0;
  box-shadow: none;
  color: #777;
  padding-left: 10px;
`;
export const HostFilter = ({
  value,
  handleHostChange,
  handleBlur,
  handleFocus,
  placeholder,
  position,
  style,
}) => {
  const [searchWord, setSearchWord] = useState("");
  const wrapperSRef = useRef(null);
  const [showFilterList, setShowFilterList] = useDetectOutsideClick(
    wrapperSRef,
    false
  );
  const [selectedTitle, setSelectedTitle] = useState("");
  const [hostsFilterList, setHosts] = useState([]);

  useEffect(() => {
    var hitUrl = "hosts?per_page=30&search=" + searchWord;
    ApiService({ method: "GET", route: hitUrl })
      .then((response) => {
        console.log(response.data);
        if (response.data.status_code === 1) {
          setHosts(response.data.data.data);
          response.data.data.data.map((values) => {
            if (values.id === value) {
              setSelectedTitle(values.title);
            }
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [searchWord]);

  return (
    <div
      ref={wrapperSRef}
      style={Object.assign({}, style, {
        width: "212px",
        display: "inline-block",
        position: "relative",
        // verticalAlign: "middle",
      })}
    >
      <div
        style={{
          background: "#fff",
          border: "1px solid rgb(226, 226, 226)",
          height: "40px",
          fontSize: "0.97rem",
          color: "#555",
          boxSizing: "border-box",
          padding: "10px",
          fontWeight: "500",
        }}
        onClick={() => {
          setShowFilterList(true);
          setSearchWord("");
        }}
      >
        {selectedTitle ? (
          <span
            style={{
              width: "calc(100% - 40px)",
              display: "inline-block",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              height: "20px",
              verticalAlign: "top",
            }}
          >
            {selectedTitle}
          </span>
        ) : (
          <span style={{ color: "#555" }}>All Hosts</span>
        )}
        <ArrowDropDown
          style={{
            float: "right",
            fontSize: "19px",
            color: "#555",
            marginRight: "0",
          }}
        />
        {selectedTitle ? (
          <Close
            fontSize="small"
            style={{
              float: "right",
              fontSize: "18px",
              color: "#777",
              cursor: "pointer",
              marginRight: "0",
            }}
            onClick={() => {
              handleHostChange();
              setSelectedTitle();
            }}
          />
        ) : (
          ""
        )}
      </div>
      {showFilterList === true ? (
        <div
          style={{
            background: "#fff",
            position: "absolute",
            zIndex: "9",
            width: "200px",
            padding: "0 5px 5px",
            border: "1px solid rgb(226, 226, 226)",
            top: position == "top" ? "-275px" : "auto",
          }}
        >
          <React.Fragment>
            <Input
              value={searchWord}
              onChange={(e) => setSearchWord(e.target.value)}
              onBlur={handleBlur}
              onFocus={handleFocus}
              placeholder="Search.."
            />
            <Search
              fontSize="small"
              style={{
                verticalAlign: "middle",
                fontSize: "22px",
                color: "#ccc",
                marginRight: "0",
              }}
            />
          </React.Fragment>
          <ul
            style={{
              listStyleType: "none",
              padding: "5px 0",
              margin: "0",
              borderTop: "1px solid #e2e2e2",
              height: "220px",
              overflow: "auto",
            }}
          >
            {hostsFilterList.map((c, i) => {
              return (
                <LI
                  key={i}
                  onClick={() => {
                    setSelectedTitle(c.title);
                    setShowFilterList(false);
                    handleHostChange(c.id);
                  }}
                >
                  {c.title}
                </LI>
              );
            })}
          </ul>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
